module.exports = "/_next/static/images/AdvertisingRecipe-598fc913bcad5a97f468fdc4938c6c17.png";